module.exports = __webpack_public_path__ + "static/media/dotted.f4a79b74.svg";